<template>
	<div class="image form-group" :class="{ 'is-empty': empty, 'is-disabled': readonly }" :data-element="element.id"
		:title="readonly ? $t('app.common.readonly') : ''">
		<div class="d-flex justify-content-between align-items-center">
			<label class="element-label" :class="classes('title')" :title="required ? trans('buttons.required') : ''">
				<span v-html="macro(label)"></span>
				<small v-if="required" class="required">*</small>
			</label>
			<div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
				<app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
			</div>
		</div>
		<div class="image-row" :class="{ 'is-invalid': !valid }">
			<field-image :default-class="classes('input')" :enabled="!loading && !readonly" :placeholder="label"
				:value="value" :t-drop-to-upload="trans('buttons.droptoupload')" :t-upload="trans('buttons.upload')"
				@update:value="update"></field-image>
		</div>
		<input type="text" ref="input" class="position-absolute invisible" :value="value.length > 0 ? 'v' : ''"
			v-validate="validate" />
		<div class="invalid-feedback" :for="label" :class="{ 'd-block': !valid }">
			<span v-if="!valid">{{ $t('validation.mandatory') }}</span>
		</div>
		<small class="form-text" :class="classes('description')">
			<span v-if="description" v-html="macro(description)"></span>&nbsp;
		</small>
	</div>
</template>

<script>
import store from '../../store'
import Image from '../../../components/Image'

export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	computed: {
		description() {
			return typeof this.definition.description == 'string' ? this.definition.description : null
		},
		empty() {
			return this.value == ''
		},
		saved() {
			return this.element && this.element.value != null && this.element.value != ''
		},
		label() {
			return this.definition.title
		},
		loading() {
			return store.state.loading
		},
		preview() {
			return store.state.preview == true
		},
		readonly() {
			return store.getters.readonly(this.definition, this.saved)
		},
		required() {
			return this.options('required') == true
		},
		valid() {
			return !(this.element && this.element.valid === false)
		},
		fieldVisibleOnlyInPreview() {
			return this.definition.print_visibility == 'preview' && store.state.preview == true && store.state.complete == false
		}
	},
	data() {
		return { value: '', queue: false }
	},
	watch: {
		'element.value': {
			immediate: true,
			handler(value) {
				this.queue = false
				this.value = ''
				if (value && typeof value == 'string') {
					this.value = this.url(value)
				} else if (value && value.constructor == Array && value.length == 1 && value[0].file) {
					this.value = value[0].file
				}
				this.$nextTick(() => {
					this.queue = true
				})
			}
		}
	},
	methods: {
		classes(index) {
			return store.getters['classes'](index)
		},
		macro(value) {
			return store.getters['macro'](value)
		},
		options(value) {
			return store.getters['options'](this.definition, value)
		},
		trans(value) {
			let trans = store.getters.trans(value);
			return trans ? trans : this.$t('front.' + value)
		},
		update(value) {
			if (!this.queue) {
				return
			}
			if (this.element.value
				&& this.element.value.constructor == Array
				&& this.element.value.length == 1
				&& this.element.value[0].file == value
			) {
				return
			}
			this.$refs.input.value = value.length > 0 ? 'v' : ''
			if (this.$validate({ target: this.$refs.input })) {
				let payload = value != '' ? [{ file: value }] : value
				let gk = this.element.group + '|' + this.definition.group
				store.commit('QUEUE', { id: this.element.id, group: gk, value: payload, upload: value != '' })
			}
		},
		url(name) {
			let params = store.state.id + '/' + this.element.id + '/' + name
			if (store.state.type == 'signed-engagement') {
				return 'http://localhost/e/media/image/' + params + '/' + store.state.tenant
			}
			if (this.preview) {
				return '/app/engagements/image/' + params
			}
			return '/e/media/image/' + params
		},
		validate(event) {
			if (this.required) {
				let m = ''
				if (event.target.value.length <= 0) {
					m = this.$t('validation.required', { attribute: this.label })
				}
				event.target.setCustomValidity(m)
			}
		}
	},
	components: { 'field-image': Image }
}
</script>
